import React from "react";
import { useParams } from "react-router";

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
} from '@material-ui/core'
import { ExpandMore } from "@material-ui/icons";

import styles from '../LocationsTagsPage/LocationsTagsPage.module.css'
import DonationTable from "../LocationsTagsPage/DonationTable";
import AccountingCode from "../LocationsTagsPage/AccountingCode";
import { useFetchEvtLocationTags } from "../../queries/events/useFetchLocationTags";
import { useAutoEvt } from "../../queries/useAutoEvt";

interface Params {
    eventid: string
}

const EventDonorSnapFieldsPage = () => {
    const { eventid } = useParams<Params>()
    useAutoEvt(eventid)

    const { data } = useFetchEvtLocationTags(Number(eventid))

    return (
        <div className={styles.root}>
            <h1>DonorSnap Fields</h1>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMore fontSize="large" />}>
                    <h2>Donation Types</h2>
                </AccordionSummary>
                <AccordionDetails>
                    <div className={styles.inputsContainer}>
                        <h5>The Donation Type field is for the item’s donation record in DonorSnap or your donor management system.</h5>
                        <DonationTable donations={data?.donationtype} eventId={eventid} />
                    </div>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMore fontSize="large" />}>
                    <h2>Accounting Codes</h2>
                </AccordionSummary>
                <AccordionDetails>
                    <div className={styles.inputsContainer}>
                        <h5>The Accounting code field is for the item’s record in DonorSnap or your donor management system.</h5>
                        <AccountingCode accountingcodes={data?.accountingcode} eventId={eventid} />
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    )
}

export default EventDonorSnapFieldsPage
